export enum NotificationType {
  DAILY = 'daily_summary',
  WEEKLY = 'weekly_summary',
  INVOICE_NEW = 'invoice_new',
  CUSTOMER_REVIEW = 'customer_review',
  JOB_CANCELLED = 'job_cancelled',
  JOB_ASSIGNED = 'job_assigned',
  JOB_MEETING = 'job_meeting',
  PAYMENT_ACCEPTANCE = 'customer_online_payment_acceptance_pending',
  PAYMENT_CUSTOMER_DECLINED = 'customer_declined_online_payment_request',
  PAYMENT_CANCELLED_AUTOMATICALLY = 'auto_cancelled_customer_online_payment',
  BONUS_JOBS_TARGET_MET_REVENUE_PENDING = 'bonus_jobs_target_met_revenue_pending',
  BONUS_NEW_MONTH_NEW_TARGET = 'bonus_new_month_new_target',
  BONUS_UNLOCKED = 'bonus_unlocked',
  BONUS_MISSED = 'bonus_missed'
}

export interface NotificationMessage {
  title: string;
  body: string;
}

export interface Notification {
  bidId: string;
  created: string;
  modified: string;
  id: string;
  isNew: boolean;
  isRead: boolean;
  isSpecial: boolean;
  notificationType: NotificationType;
  contentTypeId: number;
  objectId: number;
  message: NotificationMessage;
  icon?: string;
}
